import * as React from 'react'
import { withRouter, RouteComponentProps } from 'react-router'
import { connect } from 'react-redux'
import { Switch, Route } from 'react-router'
import ViewsList from './List'
import Classes from './Classes'
import Factoids from './Factoids'
import Review from './Review'
import Success from './Success'
import Loader from '../shared/Loader'
import styled from 'styled-components'

interface IProps extends RouteComponentProps<{}> {
  loadingData: boolean
}

class Views extends React.Component<IProps, {}> {
  public render() {
    return (
      <div>
        {this.props.loadingData ? <LoadingOuter><Loader/></LoadingOuter> : (
            <Switch>
              <Route exact={true} path="/views" component={ViewsList} />
              <Route exact={true} path="/views/new" component={Classes} />
              <Route
                exact={false}
                path="/views/new/factoids"
                component={Factoids}
              />
              <Route exact={false} path="/views/new/review" component={Review} />
              <Route exact={false} path="/views/new/success/:id" component={Success} />
            </Switch>
        )}
      </div>
    )
  }
}

const LoadingOuter = styled.div`
  margin-top: 150px;
`


export default 
  withRouter(
    connect(
      (state: any) => ({ loadingData: state.data.loading }),
      null
    )(Views)
  )


// WEBPACK FOOTER //
// ./src/views/Views.tsx